import {
  type MentorshipDetails,
  useFindMentorship,
} from "@/lib/api/mentorships";
import { resolveActionTeenDisplayName } from "./context/action-suggestion";
import { useChannelMentee } from "../use-channel-mentee";

export interface ActionMentorshipContext {
  menteeId: string | null;
  mentorshipId: string | null;
  menteeName: string;
  mentorship: MentorshipDetails | undefined;
}

export function useActionMentorship(channelUrl: string): ActionMentorshipContext {
  const { currentUserId, menteeId, name } = useChannelMentee(channelUrl);

  const { data: mentorship } = useFindMentorship(currentUserId, menteeId ?? "");

  return {
    menteeId,
    mentorshipId: mentorship?.id ?? null,
    menteeName: mentorship ? resolveActionTeenDisplayName(mentorship) : name,
    mentorship,
  };
}
